// extracted by mini-css-extract-plugin
export var inlineLink = "_a7-0";
export var inlineLinkButton = "_a7-1";